var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject } from '../../../Data/Decorators/Inject';
import { injectable } from '../../../Data/Decorators/Injectable';
import { reactive } from '../../Decorators/Reactive';
import { IGetProfilesUseCaseType } from '../../../Domain/UseCases/Profile/GetProfilesUseCase/IGetProfilesUseCase';
import { IGetSelectedProfileUseCaseType } from '../../../Domain/UseCases/Profile/GetSelectedProfileUseCase/IGetSelectedProfileUseCase';
import { ISetProfileUseCaseType } from '../../../Domain/UseCases/Profile/SetProfileUseCase/ISetProfileUseCase';
let ProfilesListViewModel = class ProfilesListViewModel {
    constructor(getProfiles, getSelectedProfile, setProfile) {
        this.getProfiles = getProfiles;
        this.getSelectedProfile = getSelectedProfile;
        this.setProfile = setProfile;
        this.viewData = {
            loading: true,
            profileKeyword: '',
            profiles: []
        };
        this.updateProfile = this.updateProfile.bind(this);
        this.getSelectedProfile.execute().observe(this, profileKeyword => this.updateViewData({ profileKeyword }));
        this.getProfiles.execute().then(value => value.observe(this, profiles => this.updateViewData({ profiles })));
    }
    updateProfile(profile) {
        return this.setProfile.execute(profile);
    }
    updateViewData(update) {
        this.viewData = Object.assign(Object.assign({}, this.viewData), update);
    }
};
__decorate([
    reactive(),
    __metadata("design:type", Object)
], ProfilesListViewModel.prototype, "viewData", void 0);
ProfilesListViewModel = __decorate([
    injectable(),
    __param(0, inject(IGetProfilesUseCaseType)),
    __param(1, inject(IGetSelectedProfileUseCaseType)),
    __param(2, inject(ISetProfileUseCaseType)),
    __metadata("design:paramtypes", [Object, Object, Object])
], ProfilesListViewModel);
export { ProfilesListViewModel };
